import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('plantilla_pdf.qr_left')
    },
    {
      id: 2,
      name: i18n.t('plantilla_pdf.qr_center')
    },
    {
      id: 3,
      name: i18n.t('plantilla_pdf.qr_rigth')
    }
  ]
}

export function TIPOS_POSICION_QR (state) {
  return configHelper.getConfig(state, 'TIPOS_POSICION_QR', GenerateConfig)
}

